import { Map, Marker, addProtocol } from "maplibre-gl";
import { Protocol } from "pmtiles";
import layers from "protomaps-themes-base";

const protocol = new Protocol();
addProtocol("pmtiles", protocol.tile);

function abs(path: string) {
  const url = new URL(path, location.href);
  return url.toString();
}

class MapEmbedElement extends HTMLElement {
  declare map: Map;
  declare marker: Marker;

  connectedCallback() {
    const lng = Number(this.getAttribute("longitude"));
    const lat = Number(this.getAttribute("latitude"));
    const zoom = Number(this.getAttribute("zoom"));

    this.map = new Map({
      container: this,
      style: {
        version: 8,
        glyphs: "/maps/fonts/{fontstack}/{range}.pbf",
        sprite: abs("/maps/sprites/v4/light"),
        sources: {
          protomaps: {
            type: "vector",
            url: "pmtiles:///maps/namibia.pmtiles",
            attribution: '© <a href="https://openstreetmap.org" target="_blank">OpenStreetMap</a>',
          },
        },
        layers: layers("protomaps", "light", "en"),
      },
      center: { lng, lat },
      zoom,
      cooperativeGestures: true,
    });

    this.marker = new Marker()
      .setLngLat({ lng, lat })
      .addTo(this.map);
  }
}

customElements.define("map-embed", MapEmbedElement);
